import CommunicationKeyPairList from "components/system/communicationKeyPair/CommunicationKeyPairList";
import RouteMenu from "mrf/view/MenuRoute";
import React from "react";

export default function CommunicationKeyPair({ match }) {
    return(
        <RouteMenu match={match} indexComponent={CommunicationKeyPairList}>
        </RouteMenu>
    )
}